<mat-toolbar class="account-header">
  <button routerLink="{{ item.routerLink }}" *ngFor="let item of menuItems | orderBy: 'ordering'" mat-button fxLayout="column" fxLayoutAlign="center center">
    <mat-icon svgIcon="{{ item.icon }}" fxLayout="column" fxLayoutAlign="center center"></mat-icon>
    <div class="label" fxHide.xs>{{ item.label }}</div>
  </button>
</mat-toolbar>
